import { getPlans, getPlanTypes } from '../../plans';
import { ACLLoader } from './acl/loader';
import { Permissions } from './permissions';
// import { LinksVoter } from './voters/impl/links';
import { CollectionsVoter } from './voters/impl/collections';
// import { DesignVoter } from './voters/impl/design';
// import { ProfileVoter } from './voters/impl/profile';
// import { ReviewsVoter } from './voters/impl/reviews';
import { MessengersVoter } from './voters/impl/messengers';
import { ProductsVoter } from './voters/impl/products';
import { WebsitesVoter } from './voters/impl/websites';
import { PageTemplatesVoter } from './voters/impl/templates';
import { PageThemesVoter } from './voters/impl/themes';
import { PageStylingVoter } from './voters/impl/pageStyling';
import { PageBlocksVoter } from './voters/impl/blocks';
import { PageBlocksPublishVoter } from './voters/impl/blocksPublish';
import { ACLVoter } from './voters/impl/acl';
import { UnlimitedPlanVoter } from './voters/impl/unlimited';
import { VersionVoter } from './voters/impl/version';
import { SubscriptionFormFieldVoter } from './voters/impl/subscriptionFormField';

export { isUnpaid } from './request';
export { AccessRequestError } from './requestError';

export { WebsitesVoter };

let acl;
const aclLoader = () => {
    return acl || (acl = new ACLLoader(getPlans()).load());
};
const aclVoter = new ACLVoter(aclLoader);

const permissions = new Permissions();
permissions.addVoter(new UnlimitedPlanVoter());
permissions.addVoter(new VersionVoter({
    'ru-integrations': '<5.14',
}));
// permissions.addVoter(new LinksVoter());
// permissions.addVoter(new DesignVoter());
// permissions.addVoter(new ProfileVoter());
// permissions.addVoter(new ReviewsVoter());
permissions.addVoter(new CollectionsVoter());
permissions.addVoter(new MessengersVoter());
permissions.addVoter(new ProductsVoter());
permissions.addVoter(new WebsitesVoter());
permissions.addVoter(new PageTemplatesVoter());
permissions.addVoter(new PageThemesVoter(aclVoter));
permissions.addVoter(new PageStylingVoter(aclVoter));
permissions.addVoter(new PageBlocksVoter(aclVoter));
permissions.addVoter(new PageBlocksPublishVoter(aclVoter));
permissions.addVoter(new SubscriptionFormFieldVoter(aclVoter));
permissions.addVoter(aclVoter);

/**
 *  Query the permissions for the specified workspace member to perform actions, possibly against specific target.
 *
 * @param {{ workspace: * }} payload Queried workspace entity descriptor
 * @param {string} rule Permission string (resource[:(action|?|*)])
 * @param {*} [subject] Target, against which the query is executed
 * @param {string} role User role (tariff plan)
 * @returns {boolean} Result of querying
 */
export const isGranted = (payload, rule, subject, role) =>
    permissions.isGranted(payload, role || payload?.workspace?.billing?.plan, rule, subject);

export const lookupUpgrade = (payload, permission, subject) => {
    const { UPGRADEABLE } = getPlanTypes();
    const role = payload.workspace?.billing?.plan;
    const roles = aclVoter.acl.getRoleIds();
    const index = roles.indexOf(role);

    if (index >= 0) {
        for (const role of roles.slice(index + 1)) {
            if (!UPGRADEABLE.includes(role)) {
                continue;
            }

            const granted = permissions.isGranted(payload, role, permission, subject);

            if (granted) {
                return role;
            }
        }
    }
};
